<template>
  <div class="content">
    <div class="md-layout details_container">
      <div class="back_btn" @click="goBack()">Back</div>
      <div v-if="listingDetails" class="md-layout md-alignment-center flex-column">
        <h2>{{listingDetails.external_listing_name}}</h2>
        <p class="py-3">
          <md-icon>navigation</md-icon>
          {{listingDetails?.address?.address}},
          {{listingDetails?.address?.street}},
          {{listingDetails?.address?.city}},
          {{listingDetails?.address?.country}}
        </p>
        <div class="md-layout w-100">
          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            <stats-card data-background-color="green">
              <template slot="header">
                <md-icon>home</md-icon>
              </template>

              <template slot="content">
                <h3 class="title">&nbsp; </h3>
              </template>

              <template slot="footer">
                <div class="stats">
                  <md-icon>home</md-icon>
                  <strong>{{listingDetails.external_listing_name}}</strong>

                </div>
              </template>
            </stats-card>
          </div>
          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            <stats-card data-background-color="orange">
              <template slot="header">
                <md-icon>groups</md-icon>
              </template>

              <template slot="content">
                <h3 class="title">&nbsp; </h3>
              </template>

              <template slot="footer">
                <div class="stats">
                  <md-icon>groups</md-icon>
                  <strong>{{listingDetails.person_capacity}} Guests</strong>
                </div>
              </template>
            </stats-card>
          </div>
          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            <stats-card data-background-color="red">
              <template slot="header">
                <md-icon>sensor_door</md-icon>
              </template>

              <template slot="content">
                <h3 class="title">&nbsp; </h3>
              </template>

              <template slot="footer">
                <div class="stats">
                  <md-icon>sensor_door</md-icon>
                  <strong>{{listingDetails.number_of_bedrooms}} Bedrooms</strong>
                </div>
              </template>
            </stats-card>
          </div>
          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            <stats-card data-background-color="blue">
              <template slot="header">
                <md-icon>hotel</md-icon>
              </template>

              <template slot="content">
                <h3 class="title">&nbsp; </h3>
              </template>

              <template slot="footer">
                <div class="stats">
                  <md-icon>hotel</md-icon>
                  <strong>{{listingDetails.number_of_beds}} Beds</strong>
                </div>
              </template>
            </stats-card>
          </div>
          <!--        <md-icon>home</md-icon>-->
        </div>
        <div class="py-3 w-100">
          <div class="md-layout w-100">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
              <stats-card>
                <template slot="content">
                  <h3 class="title p-2">Listing Info </h3>
                </template>
                <template slot="content">
                  <div class="d-flex flex-column" v-if="listingDetails.additional_info">
                    <div>
                      Check-in time start: {{listingDetails.additional_info.check_in_time_start || '_'}}  _
                      Check-in time end: {{listingDetails.additional_info.check_in_time_end}}
                    </div>
                    <div>Check-out time: {{listingDetails.additional_info.check_out_time}}</div>
                    <div>Door code: {{listingDetails.additional_info.door_code || '- - - -'}}</div>
                    <div>Key pickup: {{listingDetails.additional_info.key_pickup || '-'}}</div>
                    <div>Wi-fi username: {{listingDetails.additional_info.wi_fi_username || '-'}}</div>
                    <div>Wi-fi password: {{listingDetails.additional_info.wi_fi_password || '-'}}</div>
                  </div>
                </template>
                <template slot="footer">
                  <div class="d-flex flex-column" v-if="listingDetails.address">
                    <div>Address: {{listingDetails.address.address || '_'}}</div>
                    <div>Public address: {{listingDetails.address.public_address || '_'}}</div>
                    <div>City: {{listingDetails.address.city || '_'}}</div>
                    <div>State: {{listingDetails.address.state || '_'}}</div>
                    <div>Country: {{listingDetails.address.country || '_'}}</div>

                  </div>
                </template>
              </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
              <stats-card>
                <template slot="content">
                  <h3 class="title p-2">Amenities </h3>
                </template>
                <template slot="footer">
                  <div class="d-flex flex-column" v-if="allAmenitiesWithStatus && allAmenitiesWithStatus.length > 0">
                    <div v-for="amenity in allAmenitiesWithStatus" :key="amenity.id" class="py-1">
                      <span :class="amenity.hasAmenity ? 'mark_icon' : 'mark_icon_x'"></span> {{ amenity.name }}
                    </div>
                  </div>
                  <div v-else-if="listingDetails.amenities && !Array.isArray(listingDetails.amenities)" class="d-flex flex-column">
                    <div>Air condition: {{getYesNo(listingDetails.amenities.air_condition)}}</div>
                    <div>Kitchen: {{getYesNo(listingDetails.amenities.kitchen)}}</div>
                    <div>Pets allowed: {{getYesNo(listingDetails.amenities.pets_allowed)}}</div>
                    <div>Hot tub: {{getYesNo(listingDetails.amenities.hot_tub)}}</div>
                    <div>Swimming pool: {{getYesNo(listingDetails.amenities.swimming_pool)}}</div>
                    <div>Washing machine: {{getYesNo(listingDetails.amenities.washing_machine)}}</div>
                    <div>Free Wi-fi: {{getYesNo(listingDetails.amenities.free_wi_fi)}}</div>
                    <div>Beach front: {{getYesNo(listingDetails.amenities.beach_front)}}</div>
                    <div>Suitable for children: {{getYesNo(listingDetails.amenities.suitable_for_children)}}</div>
                    <div>Street parking: {{getYesNo(listingDetails.amenities.street_parking)}}</div>
                  </div>
                  <div v-else class="text-muted">No amenities available</div>
                </template>
              </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
              <stats-card>
                <template slot="content">
                  <h3 class="title p-2">Price and fee </h3>
                </template>
                <template slot="footer">
                  <div class="d-flex flex-column" v-if="listingDetails.price_and_fee">
                    <div>Currency: {{listingDetails.price_and_fee.currency_code}}</div>
                    <div>Guests included: {{listingDetails.price_and_fee.guests_included || 0}}</div>
                    <div>Cleaning fee: {{listingDetails.price_and_fee.cleaning_fee || 0}}</div>
                    <div>Weekly discount: {{listingDetails.price_and_fee.weekly_discount || 0}}</div>
                    <div>Monthly discount: {{listingDetails.price_and_fee.monthly_discount || 0}}</div>
                    <div>Price for extra person: {{listingDetails.price_and_fee.price_fo_extra_person || 0}}</div>
                    <div>Price: {{listingDetails.price_and_fee.price || 0}}</div>
                  </div>
                </template>
              </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
              <stats-card>
                <template slot="content">
                  <h3 class="title p-2">Rooms </h3>
                </template>
                <template slot="footer">
                  <div class="d-flex flex-column w-100 p-1" v-if="listingDetails.rooms">
                    <div class="d-flex flex-column" v-for="room in listingDetails.rooms" :key="room.id">
                      <div>Room number: {{room.room_number}}</div>
                      <div>Bed Type: {{room.type.name}}</div>
                      <div>Quantity: {{room.quantity}}</div>
                      <md-divider class="w-100 my-1"></md-divider>
                    </div>
                  </div>
                </template>
              </stats-card>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {StatsCard} from "@/components";
import {mapActions} from "vuex";
export default {
  name: "ListingDetails",
  data() {
    return {
      listingDetails: {},
      allAmenities: []
    }
  },
  components: {
    StatsCard
  },
  computed: {
    allAmenitiesWithStatus() {
      if (!this.allAmenities || this.allAmenities.length === 0) {
        return [];
      }

      const listingAmenities = this.listingDetails.amenities;
      const listingAmenityIds = Array.isArray(listingAmenities) 
        ? listingAmenities.map(a => a.id)
        : [];

      return this.allAmenities.map(amenity => ({
        id: amenity.id,
        name: amenity.name,
        hasAmenity: listingAmenityIds.includes(amenity.id)
      }));
    }
  },
  created() {
    // this.listingDetails = this.$route.params.data
  },
  mounted() {
    this.fetchListingSettings();
    this.fetchListingDetails();
  },
  methods: {
    ...mapActions(['getListingById', 'getListingSettings']),
    async fetchListingSettings() {
      this.getListingSettings()
        .then(res => {
          if (res && res.data && res.data.data && res.data.data.amenities) {
            this.allAmenities = res.data.data.amenities;
          }
        })
        .catch(err => {
          console.error('Error fetching listing settings:', err);
        });
    },
    async fetchListingDetails() {
      const id = this.$route.params.id;
      this.getListingById(id)
          .then(res => {
            this.listingDetails = res.data.data
          })
    },
    getYesNo(status) {
      return status == 1 ? 'Yes': 'No'
    },
    goBack() {
      this.$router.go(-1)
    },

  }
}
</script>

<style scoped lang="scss">
::v-deep .md-card-content {
  text-align: unset !important;
}
.back_btn {
  color: #303030;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  position: absolute;
  top: 70px;
  left: 50px;
  cursor: pointer;
  @media screen and (max-width: 1680px) {
    top: 70px;
  }
  @media screen and (max-width: 1024px) {
    left: 45px;
  }
  @media screen and (max-width: 540px) {
    left: 40px;
    top: 60px;
  }
  @media screen and (max-width: 440px) {
    left: 35px;
  }

  &:before {
    content: '';
    width: 16px;
    height: 16px;
    display: inline-block;
    position: absolute;
    top: 2px;
    left: -15px;
    background: url("~@/assets/icons/left_arrow.svg");
  }
}

.mark_icon {
  width: 24px;
  height: 24px;
  background: url("~@/assets/icons/check_ circle.svg");
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}

.mark_icon_x {
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
  position: relative;
  
  &::before {
    content: '';
    width: 24px;
    height: 24px;
    border: 2px solid #999;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
  
  &::after {
    content: '×';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #999;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
  }
}
</style>
